export const SoftwarePermissionCode = {
    Login: "SW_Login",
    UsersView: "SW_Users_View",
    UsersUpdate: "SW_Users_Update",
    RolesView: "SW_Roles_View",
    RolesUpdate: "SW_Roles_Update",
    LocationsRemoteUnlock: "SW_Locations_RemoteUnlock",
    LocationGroupsUpdate: "SW_LocationGroups_Update",
    LocationGroupsActivatePresets: "SW_LocationGroups_ActivatePresets",
    LocationSettings: "SW_Location_Settings",
    LocationTags: "SW_Location_Tags",
    CardsStaffUpdate: "SW_Cards_Staff_Update",
    CardsGuestUpdate: "SW_Cards_Guest_Update",
    AutomationsView: "SW_Automations_View",
    AutomationsUpdate: "SW_Automations_Update",
    AuditLogView: "SW_AuditLog_View",
    AccessLogView: "SW_AccessLog_View",
    AlarmsLogView: "SW_Alarms_Log_View",
    ValueLogView: "SW_Value_Log_View",
    AnalyticsView: "SW_Analytics_View",
    AlarmsSosReceive: "SW_Alarms_SOS_Receive",
    AlarmsRoomBurglaryReceive: "SW_Alarms_Room_Burglary_Receive",
    AlarmsRoomSafeBurglaryReceive: "SW_Alarms_Room_Safe_Burglary_Receive",
    AlarmsTemperatureDifferenceReceive: "SW_Alarms_Temperature_Difference_Receive",
    AlarmsWaterFloodReceive: "SW_Alarms_Water_Flood_Receive",
    AlarmsPowerOutageReceive: "SW_Alarms_Power_Outage_Receive",
    AlarmsDCOutputsFailureReceive: "SW_Alarms_DC_Outputs_Failure_Receive",
    AlarmsControllerTemperatureReceive: "SW_Alarms_Controller_Temperature_Receive",
    AlarmsWindowOpenTooLongReceive: "SW_Alarms_Window_Open_Too_Long_Receive",
    AlarmsDoorOpenTooLongReceive: "SW_Alarms_Door_Open_Too_Long_Receive",
    AlarmsRoomSafeCommErrorReceive: "SW_Alarms_Room_Safe_Comm_Error_Receive",
    AlarmsCommunicationErrorReceive: "SW_Alarms_Communication_Error_Receive",
    Settings: "SW_Settings",
    SettingsPresets: "SW_Settings_Presets",
    SettingsManageRoomOverview: "SW_Settings_Manage_Room_Overview",
    SettingsDefaults: "SW_Settings_Defaults",
    SettingsLicensing: "SW_Settings_Licensing",
    SettingsEncoders: "SW_Settings_Encoders",
    SettingsCardEventLog: "SW_Settings_Card_Event_Log",
    SettingsSubscription: "SW_Settings_Subscriptions",
    ObjectViewAll: "SW_Object_View_All",
    OdStaff: "OD_Staff"

} as const;


export type SoftwarePermissionCode =
  typeof SoftwarePermissionCode[keyof typeof SoftwarePermissionCode];
